<template>
  <row class="procedures-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="procedure in procedures" :key="procedure.id">
      <procedures-item
        :procedure="procedure"
        :all="all"
        :object="object"
        @open-procedure="openProcedure"
      />
    </i-col>
  </row>
</template>

<script>
import ProceduresItem from './procedures-item'

export default {
  props: ['procedures', 'all', 'object'],
  components: {
    ProceduresItem
  },
  methods: {
    openProcedure (payload) {
      this.$emit('open-procedure', payload)
    }
  }
}
</script>

<style>
</style>
